import {notify} from './controls/Notifications';
export default notify;



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/notify.js
 **/